import axios from 'axios';
import Button, { ButtonWrapper } from 'blocks/Button';
import Form, { TextField } from 'components/Form';
import BaseModal from 'components/modals/BaseModal';
import { resetFields } from 'helper/InputField';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import urls from 'utils/urls';
import { ContentProps, KidsProps } from './modalChangePassKids.interface';
import * as S from './modalChangePassKids.styles';

const Content = ({ open, closeModal, kid, onsubmit }: ContentProps) => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm<any>();

  const [loading, setLoading] = useState<boolean>(false);
  if (!kid) return null;

  const handleClose = () => {
    closeModal();

    resetFields(['password', 'confirmPassword'], setValue);
  };

  const submitHandler = (data: any) => {
    const url = urls.changePasswordKids(kid.id);
    axios
      .patch(url, {
        newPassword: data.password,
      })
      .then((res) => {
        console.log(res);
        toast.success(t('pages.kids.sections.tables.kids.changePassword.alert'));
        reset();
      })
      .catch((ex) => {
        toast.error(ex.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
        closeModal();
      });
    onsubmit && onsubmit(data.password);
  };

  return (
    <S.Wrapper>
      <Form>
        <TextField
          type="password"
          control={register('password', {
            required: {
              value: true,
              message: t('pages.kids.sections.tables.kids.changePassword.passwordMessage'),
            },
          })}
          required
          label={t('pages.kids.sections.tables.kids.changePassword.passwordLabel')}
          error={errors.password}
        />
        <TextField
          type="password"
          control={register('confirmPassword', {
            required: {
              value: true,
              message: t('pages.kids.sections.tables.kids.changePassword.confirmPasswordMessage'),
            },
            // validate: (value, formValues) =>
            //   value === formValues.password
            //     ? true
            //     : t('pages.kids.sections.tables.kids.changePassword.confirmPasswordValidate'),
          })}
          required
          label={t('pages.kids.sections.tables.kids.changePassword.confirmPasswordLabel')}
          error={errors.confirmPassword}
        />

        <S.Buttons as={ButtonWrapper} justify="center" topSpace="medium">
          <S.Button as={Button} loading={loading} onClick={() => handleSubmit(submitHandler)()}>
            {t('pages.kids.sections.tables.kids.changePassword.btnConfirm')}
          </S.Button>
          <Button color="danger" onClick={handleClose}>
            {t('pages.kids.sections.tables.kids.changePassword.btnCancel')}
          </Button>
        </S.Buttons>
      </Form>
    </S.Wrapper>
  );
};

interface State {
  open: boolean;
  kid: KidsProps | null;
  onsubmit;
}

interface Props {
  ref: any;
}

class ModalChangePassKids extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      kid: null,
      onsubmit: () => { },
    };
  }

  openModal = (kid: KidsProps): void => this.setState({ open: true, kid, onsubmit });

  closeModal = (): void => this.setState({ open: false });

  render() {
    return (
      <S.KidsDetailModalContainer as={BaseModal} open={this.state.open} closeModal={this.closeModal}>
        {this.state.kid ? (
          <Content
            {...this.props}
            open={this.state.open}
            closeModal={this.closeModal}
            kid={this.state.kid}
            onsubmit={this.state.onsubmit}
          />
        ) : null}
      </S.KidsDetailModalContainer>
    );
  }
}

export default ModalChangePassKids;
